package com.macrofocus.eflux.ui.svg

import react.StateSetter
import web.html.HTMLDivElement

fun resize(div: HTMLDivElement, setWidth: StateSetter<Int>, setHeight: StateSetter<Int>) {
    val width = div.clientWidth // Todo: offsetWidth
    val height = div.clientHeight // Todo: offsetHeight
    setWidth(width)
    setHeight(height)
}
